import _tslib from "tslib";
import _pako from "pako";
import { dew as _errorsDew } from "../errors";
import { dew as _PDFNameDew } from "../objects/PDFName";
import { dew as _PDFStreamDew } from "../objects/PDFStream";
import { dew as _utilsDew } from "../../utils";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var tslib_1 = _tslib;

  var pako_1 = tslib_1.__importDefault(_pako);

  var errors_1 = _errorsDew();

  var PDFName_1 = tslib_1.__importDefault(_PDFNameDew());

  var PDFStream_1 = tslib_1.__importDefault(_PDFStreamDew());

  var utils_1 = _utilsDew();

  var PDFFlateStream =
  /** @class */
  function (_super) {
    tslib_1.__extends(PDFFlateStream, _super);

    function PDFFlateStream(dict, encode) {
      var _this = _super.call(this, dict) || this;

      _this.computeContents = function () {
        var unencodedContents = _this.getUnencodedContents();

        return _this.encode ? pako_1.default.deflate(unencodedContents) : unencodedContents;
      };

      _this.encode = encode;
      if (encode) dict.set(PDFName_1.default.of("Filter"), PDFName_1.default.of("FlateDecode"));
      _this.contentsCache = utils_1.Cache.populatedBy(_this.computeContents);
      return _this;
    }

    PDFFlateStream.prototype.getContents = function () {
      return this.contentsCache.access();
    };

    PDFFlateStream.prototype.getContentsSize = function () {
      return this.contentsCache.access().length;
    };

    PDFFlateStream.prototype.getUnencodedContents = function () {
      throw new errors_1.MethodNotImplementedError(this.constructor.name, "getUnencodedContents");
    };

    return PDFFlateStream;
  }(PDFStream_1.default);

  exports.default = PDFFlateStream; //# sourceMappingURL=PDFFlateStream.js.map

  return exports;
}